import { Order } from './order.model';

export interface OrderState {
  selectedOrder: Order | null;
  isPaymentCompleted: boolean | null;
}

export const initialState: OrderState = {
  selectedOrder: null,
  isPaymentCompleted: null,
};
